<template>
  <section>
    <UAnnouncement></UAnnouncement>
    <HeaderDefault></HeaderDefault>
    <UHero></UHero>
    <UTicker />

    <UAlert></UAlert>
    <UBrowsebytype></UBrowsebytype>
    
    <!-- Buzz Posts Section -->
    <BuzzCardHome></BuzzCardHome>
    <UMembers></UMembers>

    <UBanner></UBanner>
    <FooterDefault></FooterDefault>
  </section>
</template>

<style>

</style>
<script setup>
useSeoMeta({
  title: "Academic Alerts - Verified Updates on your Inbox",
  ogTitle: "AcademicAlerts.org - One Stop updates for academicians",
  description: "AcademicAlerts.org - One Stop updates for academicians.",
  ogDescription:
    "At Academic Alerts, we believe in creating a dynamic space for scholars, researchers, and enthusiasts to connect and share their passion for knowledge.",
  ogImage: "https://academicalerts.org/images/placeholder.jpg",
  twitterCard: "summary_large_image",
});
</script>
